<template>
    <div class="container">
        <div class="row mt-2" v-if="!isLoading && layout=='grid'">
            <template v-for="input in forms">
                <div :class="getResponsiveClass(input)" v-if="input.type=='line'" v-bind:key="'f'+input.col">
                    <hr/>
                </div>

                <div :class="getResponsiveClass(input)" v-if="input.type=='label'" v-bind:key="input.col">
                    <h2 class="mobile-heading">{{input.defaultValue}}</h2>
                </div>

                <b-form-group :class="getResponsiveClass(input)" v-bind:key="'f'+input.col" v-if="input.visible && isFormControl(input)" :set="field = columns[input.col]">
                        <label class="input-header mobile-label" >{{field ? field.alias : ''}} </label>
                        <!-- <label class="input-header" >Debug: {{field ? field.name : ''}} </label> -->
                        
                        <br/>
                    
                        <div v-if="input.type=='checkbox'">
                            <b-form-checkbox
                                v-model="input.value"
                                value="true"
                                unchecked-value="false"
                                :disabled="true"
                                >
                                {{field.alias}}
                                </b-form-checkbox>
                        </div>

                        <div v-else-if="input.type=='image'" class="mobile-image-container">
                            <b-img thumbnail :width="isMobile ? 100 : 120" :src="input.value" fluid alt="-"></b-img>
                        </div>

                        <div v-else-if="input.type=='multi-select'">
                            <span v-if="!Array.isArray(input.value)" class="mobile-text">{{input.value}}</span>
                            <ul v-else class="mobile-list">
                                <li v-for="text in input.value" v-bind:key="text" class="mr-2 mobile-list-item">
                                    {{text}}
                                </li>
                            </ul>
                        </div>

                        <div v-else-if="input.type=='image_list'" class="mobile-image-gallery">
                            <div v-for="(images,i) in input.value" v-bind:key="images + i" class="mr-2 mobile-image-group">
                                <div class="my-3 mobile-date-label"><em>{{images.date}}</em></div>
                                <div class="mobile-images-row">
                                    <div v-for="(url,i) in images.urls" v-bind:key="url + i" class="image thumbnail mobile-thumbnail">
                                        <img :src="url" v-on:click="openModal(url)">
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-else-if="input.type=='link'">
                            <a :href="input.value" target="_blank" v-if="input.value" class="mobile-link">{{input.value?input.value: '-'}}</a>
                        </div>

                        <div v-else class="mobile-text">
                            {{input.value?input.value: '-'}} 
                           
                        </div>

                        <div v-if="input.action_copy" class="mobile-copy-button">
                            <b-button size="sm" class="mb-2" v-if="input.value != ''" @click="copyToClipboard(input.value)">
                                Copy
                            </b-button>
                        </div>

                    
                </b-form-group>
            </template>
        </div>

        <div class="row mt-2" v-if="!isLoading && layout=='list'">
            <template v-for="input in forms">

                <div :class="'col-'+(input.colspan?input.colspan:6)" v-if="input.type=='line'" v-bind:key="'l'+input.col">
                    <hr/>
                </div>

                <div class="col-12" v-bind:key="'l'+input.col" v-if="input.type!=='line'" :set="field = columns[input.col]">
                    <p><span class="input-header">{{field.alias}}</span>: {{input.value?input.value:'-'}}</p>
                </div>
            </template>
        </div>

        <div class="row" v-if="isLoading">
            Loading...
        </div>

        <div ref="imgModalRef" class="modal">
            <span class="close" v-on:click="closeModal">&times;</span>
            <img class="modal-content" ref="imgContentRef">
        </div>
    </div>

</template>

<script>
import VueBootstrapTypeahead from 'vue-typeahead-bootstrap'
import Multiselect from 'vue-multiselect'

import Constants from '@/constants'
import TableMeta from '@/models/OnlineScanTableMeta'
import StreetData from '@/models/StreetData'
import moment from 'moment'
import axios from 'axios'

// import ProductService from '@/services/productService'

export default {
  name: 'GenericDetailView',
  components: {
    'vue-bootstrap-typeahead': VueBootstrapTypeahead,
    Multiselect
  },
  props: {
      'rootPath': String,
      'forms': Array, 
      'columns': Object, 
      'table_name': String, 
      'service': Object,
      'layout': {
          type: String,
          default: 'grid'
      },
      'modalClientId': Number
    },
  computed: {
    role() {
        console.log('trying to get user role: ', this.$store.state.userRole)
        if (this.$store.state.userRole) {
            return this.$store.state.userRole;
        }

        return 'sale'; // default role
    },

    can_see_sensitive_customer_data () {
      if (this.$store.getters.role == 'admin'
        || (this.$store.getters.permissions && this.$store.getters.permissions['product_sensitive_data'])
        || (this.$store.getters.userEmail === this.created_by)
        ) 
      {
        return true;
      }

      return false;
    },

    isMobile() {
      return window.innerWidth <= 768;
    }
  },
  data () {
    return {
        debugMode: false,
        fields_map: {},
        id: null,
        isLoading: false,

        created_by: '',
    }
  },
  watch: {
      id: function (val) {
        this.id = val;
        this.refresh();
    },
  },
  methods: {
      getResponsiveClass(input) {
        const colspan = input.colspan || 6;
        
        // On mobile, make most fields full width, except for small fields
        if (colspan <= 3) {
          return `col-12 col-sm-6 col-md-${colspan}`;
        } else if (colspan <= 6) {
          return `col-12 col-md-${colspan}`;
        } else {
          return `col-12`;
        }
      },

      isURL(v) {
        let url;
  
        try {
            url = new URL(string);
        } catch (_) {
            return false;  
        }

        return url.protocol === "http:" || url.protocol === "https:";
      },

      isFormControl(input) {
          return input.type!='line' && input.type != 'label'
      },
    createNewItem () {
        this.$router.replace({ path: `${this.rootPath}/new` }) 
    },

    parseRecordIntoFormValue(record) {
        for(var i = 0; i<this.forms.length; i++) {
            if(this.forms[i].type === 'line' || this.forms[i].type === 'images') {
                // skip this as this is a non-column field
                continue;
            }

            if(record[this.forms[i].col]) {
                var v = record[this.forms[i].col];

                var form = this.forms[i]

                if(form.type === 'date') {
                    form.value= moment(v).format('yyyy-MM-DD');
                } else if(form.type === 'multi-select') {
                    form.value= v.split(',');
                } else if(form.type === 'checkbox') {
                    form.value= (v == 1?true:false);
                } else if(form.type === 'typeahead') {
                    form.value = v;
                } else if(form.type === 'image_list') {
                    const images = JSON.parse(v);

                    // console.log('parsed image_list: ', v, images);

                    const date_images = this.getDateImages(images);

                    form.value = date_images;
                }
                else {
                    form.value=v;
                }
                
                if (this.forms[i].col == 'fullname' || this.forms[i].col == 'phone') {
                    if ((this.role != 'admin') && (this.created_by != this.$store.state.userEmail)) {
                        form.value = '*****';
                    }
                }

                if(!this.can_see_sensitive_customer_data) {
                    var sensitive_columns = [
                        'notes', 'link', 'image_list', 'phone', 'fullname','type',
                        'contract_type', 'contract_start_date', 'contract_end_date', 'commission'];

                    if(sensitive_columns.includes(this.forms[i].col))
                    {
                        form.value = '*****';
                    }
                }
                
                form.oldValue = form.value;
            }
        }

        console.log('record after parsed: ', this.forms);
    },

    async refresh () {
        console.log('refresh');
        this.resetFormValue();
        this.isLoading = true;
        if(!this.id) {
            this.isLoading = false;
            return;
        }

        if(this.service) {

            var recordInfo = await this.service.getDetail(this.id);
            this.parseRecordIntoFormValue(recordInfo);

            if (recordInfo.created_by) {
                this.created_by = recordInfo.created_by;
            }
        }
        else {
            console.log('Error::Cannot find the service');
        }
        // var productService = new ProductService(this.table_name);

        this.isLoading = false;
    },

    resetFormValue () { 
        for(var i=0; i<this.forms.length;i++) {
            this.forms[i].value = this.forms[i].defaultValue;
        }
    },

    openModal(url) {
        this.$refs.imgModalRef.style.display = "block";
        this.$refs.imgContentRef.src = url;
    },

    closeModal() {
        this.$refs.imgModalRef.style.display = "none";
    },

    getDateImages(images) {
        let temp = [...images];
        let _date_images = [];

        temp.map((img) => {
            if (!_date_images[img.time]) {
                _date_images[img.time] = [];
            }

            _date_images[img.time].push(img.url);
        })

        let date_images = [];

        for (const time in _date_images) {
            date_images.push({date: time, urls: _date_images[time]});
        }

        date_images = date_images.sort((a,b) => b.date.localeCompare(a.date));

        return date_images;
    },

    copyToClipboard (value) {
        var tempInput = document.createElement("input");
        tempInput.value = value;
        document.body.appendChild(tempInput);
        tempInput.select();
        document.execCommand("copy");
        document.body.removeChild(tempInput);
    },
  },
  mounted () {
      this.resetFormValue();

      this.id = this.modalClientId ? this.modalClientId : this.$route.params.id;
      console.log('id: ' + this.id);

      this.refresh()
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped> 

.text-red {
    color: red;
}

.input-header {
    font-weight: bold;
}

.image {
    display: inline-block;
    margin: 5px;
    cursor: pointer;
}

.center-cropped {
  object-position: center; /* Center the image within the element */
  height: 150px;
  width: 150px;
}

.thumbnail {
  position: relative;
  width: 200px;
  height: 200px;
  overflow: hidden;
}
.thumbnail img {
  position: absolute;
  left: 50%;
  top: 50%;
  height: 100%;
  width: auto;
  -webkit-transform: translate(-50%,-50%);
      -ms-transform: translate(-50%,-50%);
          transform: translate(-50%,-50%);
  transition: transform .2s;
}
.thumbnail img.portrait {
  width: 100%;
  height: auto;
}

/* The Modal (background) */
.modal {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.9); /* Black w/ opacity */
}

/* Modal Content (Image) */
.modal-content {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 700px;
}

/* Add Animation - Zoom in the Modal */
.modal-content {
  animation-name: zoom;
  animation-duration: 0.6s;
}

@keyframes zoom {
  from {transform:scale(0)}
  to {transform:scale(1)}
}

/* The Close Button */
.close {
  position: relative;
  right: 35px;
  color: #f1f1f1;
  font-size: 40px;
  font-weight: bold;
  transition: 0.3s;
}

.close:hover,
.close:focus {
  color: #bbb;
  text-decoration: none;
  cursor: pointer;
}

/* 100% Image Width on Smaller Screens */
@media only screen and (max-width: 700px){
  .modal-content {
    width: 100%;
  }
}

/* Mobile-friendly styles */
@media (max-width: 768px) {
  .mobile-heading {
    font-size: 1.5rem;
    margin-bottom: 1rem;
    text-align: center;
  }

  .mobile-label {
    font-size: 0.9rem;
    margin-bottom: 0.5rem;
    color: #666;
  }

  .mobile-text {
    font-size: 1rem;
    line-height: 1.4;
    word-wrap: break-word;
    padding: 8px 0;
  }

  .mobile-link {
    font-size: 0.9rem;
    word-break: break-all;
    color: #007bff;
  }

  .mobile-list {
    padding-left: 1rem;
    margin-bottom: 0;
  }

  .mobile-list-item {
    margin-bottom: 0.25rem;
    font-size: 0.9rem;
  }

  .mobile-image-container {
    text-align: center;
    margin: 0.5rem 0;
  }

  .mobile-image-gallery {
    margin: 0.5rem 0;
  }

  .mobile-image-group {
    margin-bottom: 1rem;
  }

  .mobile-date-label {
    font-size: 0.8rem;
    color: #666;
    margin-bottom: 0.5rem;
  }

  .mobile-images-row {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    justify-content: flex-start;
  }

  .mobile-thumbnail {
    width: 80px;
    height: 80px;
    flex-shrink: 0;
  }

  .mobile-thumbnail img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .mobile-copy-button {
    margin-top: 0.5rem;
  }

  /* Improve spacing for mobile */
  .container .row {
    margin-left: -8px;
    margin-right: -8px;
  }

  .container .row > [class*="col-"] {
    padding-left: 8px;
    padding-right: 8px;
    margin-bottom: 1rem;
  }

  /* Better form group spacing */
  .form-group {
    margin-bottom: 1.5rem;
  }

  /* Responsive hr */
  hr {
    margin: 1rem 0;
  }
}
</style>

<style>
.vbst-item {
    background: white;
}
</style>
